import { Column, CreateDateColumn, Entity, OneToMany, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { BomEntity } from "./bom-entity";
import { StyleComboEntity } from "./style-combo-entity";
import { ItemTypeEnum, UOMEnum } from "@project-management-system/shared-models";
import { ZFactorsEntity } from "./z-factors.entity";

@Entity('carton_box')
export class CartonBoxEntity {
    @PrimaryGeneratedColumn('increment', {
        name: 'carton_box_id'
    })
    cartonBoxId: number;

    @Column('varchar', {
        name: 'style',
        length: 15,
    })
    style: string;

    @Column('varchar', {
        name: 'carton_code',
        length: 15,
    })
    cartonCode: string;

    @Column('varchar', {
        name: 's_l',
        length: 50,
    })
    stoL: number;

    @Column('varchar', {
        name: 'xl_bal',
        length: 50,
    })
    xlToBal: number;

  

    @CreateDateColumn({
        name: 'created_at'
    })
    createdAt: Date;

    @Column('varchar', {
        nullable: true,
        length: 50,
        name: 'created_user'
    })
    createdUser: string | null;

    @UpdateDateColumn({
        name: 'updated_at'
    })
    updatedAt: Date;

    @Column('varchar', {
        nullable: true,
        length: 50,
        name: 'updated_user'
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: 'version_flag'
    })
    versionFlag: number;

    @Column('boolean', {
        nullable: false,
        name: 'is_active',
        default: true
    })
    isActive: boolean;


}